import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a brick chimney stack: a square brick column rising to about
// 3.2 m (clear of a 2.6 m storey and its roof) with a projecting concrete
// cap and a short darker flue on top.
const BRICK = "#a05a40";
const BRICK_DARK = "#8c4c34";
const CONCRETE = "#9a9a94";
const FLUE = "#4a4a4c";

export const chimney = defineModel({
  id: "chimney",
  batchId: "modern",
  name: "Chimney",
  tags: ["modern", "outdoor", "structure", "chimney", "roof", "brick"],
  summary: "A square brick chimney stack with a concrete cap and flue, 3.2 m tall.",
  description:
    "A one-tile brick chimney of the Modern Living kit: a 0.5 x 0.5 m " +
    "square brick stack rising to 3.0 m, a projecting concrete cap and a " +
    "short darker flue topping out near 3.3 m — tall enough to clear a " +
    "single storey and its roof pieces.",
  tiles: { w: 1, h: 1 },
  footprint: 1.8,
  parts(): Part[] {
    return [
      // brick stack (0 -> 3.0)
      { geometry: new THREE.BoxGeometry(0.5, 3.0, 0.5), color: BRICK, position: [0, 1.5, 0] },
      // darker brick band near the top
      { geometry: new THREE.BoxGeometry(0.52, 0.18, 0.52), color: BRICK_DARK, position: [0, 2.7, 0] },
      // darker brick base course
      { geometry: new THREE.BoxGeometry(0.56, 0.2, 0.56), color: BRICK_DARK, position: [0, 0.1, 0] },
      // projecting concrete cap (3.0 -> 3.1)
      { geometry: new THREE.BoxGeometry(0.62, 0.1, 0.62), color: CONCRETE, position: [0, 3.05, 0] },
      // short darker flue on top (3.1 -> 3.3)
      { geometry: new THREE.BoxGeometry(0.28, 0.2, 0.28), color: FLUE, position: [0, 3.2, 0] },
    ];
  },
  animations: [],
});
